import { render, staticRenderFns } from "./addPartment.vue?vue&type=template&id=7f1dfcc1&"
import script from "./addPartment.vue?vue&type=script&lang=js&"
export * from "./addPartment.vue?vue&type=script&lang=js&"
import style0 from "./addPartment.vue?vue&type=style&index=0&id=7f1dfcc1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports